<template lang="pug">
  v-row.student-review
    template(v-if="!$loader.isLoading")
      v-col(cols=12 sm=10 md=8 lg=7)
        v-card.sdo-card.no-overflow-hidden.fill-width.mt-12.px-5
          v-row(
            no-gutters
            align="end"
          ).mt-n10.nowrap
            v-avatar(
              color="grey lighten-4"
              outline
              size="100"
            )
              v-icon(x-large color="secondary") mdi-account-school
            .ml-5
              strong {{ student.full_name }}
              .caption
                span(
                  v-for="group in student.groups"
                  :key="group.id"
                ) {{ group.full_name }}

            v-spacer
          v-card-text.mt-5
            v-subheader Учебный прогресс
            select-course-subject(
              v-model="subject"
              progress-mode
              :get-courses-method="loadStudentProgress"
            )
      v-col(
        cols=12 md=4 lg=5
      )
        v-slide-y-reverse-transition
          student-task-progress-panel(
            v-if="subject"
            :subject="subject"
            :student="student"
          ).sdo-card.no-overflow-hidden.fill-width.mt-12.px-5
</template>

<script>
import SelectCourseSubject from '../components/SelectCourseSubject.vue';
import StudentTaskProgressPanel from '../components/StudentTaskProgressPanel.vue';

export default {
  components: {
    SelectCourseSubject,
    StudentTaskProgressPanel,
  },
  data: () => ({
    student: null,
    subject: null,
  }),
  async created() {
    this.$loader.start();
    await this.loadStudent();
    this.$loader.stop();
  },
  methods: {
    async loadStudent() {
      const { item } = await this.$api.users.show(this.$route.params.id);
      this.student = item;
    },
    loadStudentProgress() {
      return this.$api.users.courses(this.student.id, {
        expand: 'active_course_unit_count,complete_course_unit_count,complete_status,course_units',
      });
    },
  },
};
</script>
